import React from "react"
import { ISchedulePatternTemplate, IPosition } from "../../../../models"
import AccountStore from "../../../../stores/AccountStore"
import { grey500 } from "material-ui/styles/colors"
import * as utils from "../../../../helpers/utils"
import * as timeHelper from "../../../../helpers/timeHelper"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import moment from "moment"
import AssignedEmployeeInfoToolTipIcon from "./AssignedEmployeeInfoToolTipIcon"
import "./styles.css"
export interface IScheduleDetailMonthEvent {
	start: Date
	end: Date
	patternTemplate: ISchedulePatternTemplate
	handleGoToDayView(): void
}
interface IProps {
	event: IScheduleDetailMonthEvent
}

export const MonthEvent: React.SFC<IProps> = (props: IProps) => {
	let backgroundColor = grey500
	if (props.event.patternTemplate.ShiftTemplates.length === 1) {
		const position: IPosition = AccountStore.getCurrentAccount().PositionDefinitions.find((item) => item.Id === props.event.patternTemplate.ShiftTemplates[0].PositionId)
		backgroundColor = position && position.Color ? position.Color : AccountStore.getPositionDefaultColor()
	}

	const startEndSimpleTime = scheduleHelper.getStartEndSimpleTimeOfPatternTemplate(props.event.patternTemplate)
	const shortStartTime = timeHelper.getShortTime(moment(scheduleHelper.getTimeFromSimpleTime(startEndSimpleTime.StartSimpleTime)).toDate())
	const shortEndTime = timeHelper.getShortTime(moment(scheduleHelper.getTimeFromSimpleTime(startEndSimpleTime.EndSimpleTime)).toDate())
	const timeRange = `${shortStartTime}-${shortEndTime}`
	return (
		<div
			className="ScheduleDetailMonth-Event"
			style={{ background: backgroundColor }}
			onClick={props.event.handleGoToDayView}
		>
			{props.event.patternTemplate.AssignedUserId &&
				<AssignedEmployeeInfoToolTipIcon
					patternTemplate={props.event.patternTemplate}
				/>
			}
			<span className="ScheduleDetailMonth-EventTime">
				{timeRange}
			</span>
			<span
				className="ScheduleDetailMonth-EventTitle"
				style={{ background: utils.getMaterial900ColorFrom500Color(backgroundColor), color: "rgba(254, 254, 254, 0.5)" }}
			>
				{props.event.patternTemplate.Name}
			</span>
		</div>
	)
}